<template>
  <router-view></router-view>
</template>

<script>


export default {
  name: "LeaderLayout",
  components: {

  }
};
</script>


<style lang="scss" scoped>


</style>
